import React from 'react';

//Components
import { Formik, Form } from 'formik';

const ExtendedFormik = props => {
  const { children, ...otherprops } = props;

  return (
    <Formik validateOnChange={true} {...otherprops}>
      {formikProps => children(formikProps)}
    </Formik>
  );
};

export { ExtendedFormik, Form };
